// removed by extract-text-webpack-plugin
module.exports = {"inputGroup":"_2c2S9tpXtrOV9IThPoXliQ","flags":"L5TrsDJciv2dlBd56gnuf","active":"_3juuqmGxcoZZq10A_PBRvD","dirty":"_15qv3C4lAQxGo1ZL-Cp_zf","visited":"_3wHfpk-rluUiaUnvxxJTjw","touched":"_3JYjk5WZfGDWBwIoU_EAK3","radioLabel":"Zk2Ia0xFNNrEkxF4f-FWR","cog":"WTV9kR-EUfUU3mlvCC2D7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyForm/SurveyForm.scss
// module id = 1059
// module chunks = 0